/**
 * Shared types used across client and server
 */

/**
 * Transaction status types
 */
export type TransactionStatus = 'completed' | 'failed' | 'pending';

/**
 * Transaction type enum
 */
export enum TokenTransactionType {
  PURCHASE = 'purchase',    // User purchased tokens
  CLICK_DEBIT = 'click_debit',  // User spent tokens clicking a button
  CLICK_CREDIT = 'click_credit', // User earned tokens from someone clicking their button
  GIFT = 'gift',             // Gift tokens added by administrator
  WITHDRAWAL = 'withdrawal'  // User withdrew tokens
}

/**
 * Transaction interface for purchase history
 */
export interface Transaction {
  /** Unique identifier (usually Stripe session ID) */
  id: string;
  /** Transaction date */
  date: string | Date;
  /** Number of tokens purchased */
  tokenAmount: number;
  /** Price paid in USD */
  price: number;
  /** Transaction status */
  status: TransactionStatus;
  /** Payment method used */
  paymentMethod?: string;
  /** Reason for failure if status is 'failed' */
  failureReason?: string;
}

/**
 * Token Transaction interface for all token movements
 */
export interface TokenTransaction {
  /** Unique identifier for the transaction */
  id: string;
  /** When the transaction occurred */
  date: string | Date;
  /** Number of tokens (positive for credits, negative for debits) */
  amount: number;
  /** Transaction type */
  type: TokenTransactionType;
  /** Description of the transaction */
  description: string;
  /** Reference to related entity (button ID, counter ID, etc.) */
  reference?: string;
  /** Name of the entity (button name, counter name, etc.) */
  entityName?: string;
  /** Balance after transaction */
  balanceAfter?: number;
}

/**
 * Token package interface
 */
export interface TokenPackage {
  /** Number of tokens in the package */
  tokenAmount: number;
  /** Price in USD */
  price: number;
  /** User-friendly description */
  description?: string;
  /** Whether this is a featured package */
  featured?: boolean;
} 